import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-cdw-progress-bar',
  templateUrl: './cdw-progress-bar.component.html',
  styleUrls: ['./cdw-progress-bar.component.scss'],
  standalone: false,
})
export class CdwProgressBarComponent implements OnInit {
  @Input() value = 0;

  mode: 'indeterminate' | 'determinate' = 'indeterminate';

  ngOnInit() {
    if (!this.value) {
      this.mode = 'indeterminate';
    } else if (this.value) {
      this.mode = 'determinate';
    }
  }
}
